var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var ExchangeRateModel;
  return ExchangeRateModel = (function(_super) {

    __extends(ExchangeRateModel, _super);

    function ExchangeRateModel() {
      ExchangeRateModel.__super__.constructor.apply(this, arguments);
    }

    ExchangeRateModel.prototype.pathRoot = core.getConfig().apiPrefix + 'exchangerate.json';

    ExchangeRateModel.prototype.defaults = function() {
      return {
        currencyId: null,
        rate: null
      };
    };

    return ExchangeRateModel;

  })(BaseModel);
});
